module.exports = "images/get-inspired-4.webp";